import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { WORK_HISTORY_REPORT_QUERY } from '../../../graphql.js'
import { Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData } from '../CustomUtils.js'
import WorkHistoryReportForm from './WorkHistoryReportForm.js'
import { getTenant } from '../../../utils.js'

const WORK_HISTORY_REPORT = gql(WORK_HISTORY_REPORT_QUERY)

export default function WorkHistoryReport({ location }) {
  console.log('WorkHistoryReport rendered: ', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, WORK_HISTORY_REPORT, 'workHistoryReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    console.log(results)
    const html = results.replace(/document_controller\.display\?in_document=/g, `/${getTenant()}/object/`)
    return (
      <div className="custom-scroll">
        <WorkHistoryReportForm location={location} setResults={setResults} />
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    )
  }
}
